import { render, staticRenderFns } from "./OrderOnDemand.vue?vue&type=template&id=1e052a51&scoped=true&"
import script from "./OrderOnDemand.vue?vue&type=script&lang=js&"
export * from "./OrderOnDemand.vue?vue&type=script&lang=js&"
import style0 from "./OrderOnDemand.vue?vue&type=style&index=0&id=1e052a51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e052a51",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDatePicker,VRow})
